/**
 * Error message (an i18n key such as `Errors.SessionMessageRequiresInbound`)
 * sent by the backend, or the error's own message.
 */
export const getApiErrorMessage = (error: any, fallback: string): string =>
    error?.response?.data?.error ||
    (error instanceof Error ? error.message : fallback);
